import { axiosAPI } from '@/plugins/axios';

export const updateUserLanguage = (payload: { lang: string }) => axiosAPI.put('/me/language', payload);
